import React, { useState } from 'react'
import { DatePicker, Button, Form } from "antd";
import { showApiError, showApiSuccess } from "./utilities";


export default function Test(props) {

  function handleOKClick() {

    window.location.href = "/"
      return new Promise((resolve, reject) => {
        //setTimeout(resolve, 100);
        resolve();
      }).catch(() => console.log('Oops errors!'));

  }
  function handleClick() {

    showApiSuccess("yeah", handleOKClick) 
    console.log("showApisuccess")
    //window.location.href = "/"
  }


  return (
    <div>
      <h2>TEST PAGE</h2>
      <Button onClick={handleClick} >click me </Button>
    </div>
    )

} 